import { render, staticRenderFns } from "./Watchers.vue?vue&type=template&id=63d8ff7e&scoped=true&"
import script from "./Watchers.vue?vue&type=script&lang=js&"
export * from "./Watchers.vue?vue&type=script&lang=js&"
import style0 from "./Watchers.vue?vue&type=style&index=0&id=63d8ff7e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63d8ff7e",
  null
  
)

/* custom blocks */
import block0 from "./Watchers.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports